__turbopack_context__.v({
  "image": "ljWoSq_image",
  "skeleton": "ljWoSq_skeleton",
  "slide": "ljWoSq_slide",
  "viewMoreLink": "ljWoSq_viewMoreLink",
  "viewMoreSlide": "ljWoSq_viewMoreSlide",
});
